import { Button } from '@berky/ui'
import { ArrowDownRight } from 'lucide-react'

export function FeedbackReminder({ onClick }: { onClick: () => void }) {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      data-feedback-capture-ignore
      data-overlay-keep-open
      className="fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] right-20 z-[60] h-auto max-w-[calc(100vw-6rem)] gap-2 rounded-lg bg-background px-3 py-2 text-sm shadow-lg md:right-24"
      aria-label="Feedback geben"
    >
      Feedback geben?
      <ArrowDownRight aria-hidden="true" className="size-5 animate-bounce motion-reduce:animate-none" />
    </Button>
  )
}
